import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import {
  createCompanyVehicleStatus,
  createCompanyVehicleStatusSuccess,
  createCompanyVehicleType,
  createCompanyVehicleTypeSuccess,
  createCompanyVehicleCheckType,
  createCompanyVehicleCheckTypeSuccess,
  deleteCompanyVehicleStatus,
  deleteCompanyVehicleStatusSuccess,
  deleteCompanyVehicleType,
  deleteCompanyVehicleTypeSuccess,
  deleteCompanyVehicleCheckType,
  deleteCompanyVehicleCheckTypeSuccess,
  listCompanyVehicleStatus,
  listCompanyVehicleType,
  listCompanyVehicleCheckType,
  updateCompanyVehicleStatus,
  updateCompanyVehicleStatusSuccess,
  updateCompanyVehicleType,
  updateCompanyVehicleTypeSuccess,
  updateCompanyVehicleCheckType,
  updateCompanyVehicleCheckTypeSuccess,
} from "../../../../store/companyVehicle/action";
import { listFormApi } from "../../../../helpers/fakebackend_helper";
import CheckSchedulesPanel from "./CheckSchedulesPanel";
export default function CompanyVehicleSettings() {
  const dispatch = useDispatch();

  const {
    companyVehicleStatusListAPI,
    companyVehicleTypeListAPI,
    companyVehicleCheckTypeListAPI,
  } = useSelector((state) => ({
    companyVehicleStatusListAPI:
      state.CompanyVehicle.companyVehicleStatusList?.companyvehiclestatus_list,
    companyVehicleTypeListAPI:
      state.CompanyVehicle.companyVehicleTypeList?.companyvehicletype_list,
    companyVehicleCheckTypeListAPI:
      state.CompanyVehicle.companyVehicleCheckTypeList
        ?.companyvehiclechecktype_list,
  }));

  // Change #100439 - check types carry a default Form + repeat schedule once
  // delta 214 has added the columns (findAll then returns the keys). Until
  // then the fields are hidden and never sent.
  const checkTypeScheduleReady = (companyVehicleCheckTypeListAPI || []).some(
    (t) => t && Object.prototype.hasOwnProperty.call(t, "RepeatIntervalDays")
  );
  // Change #100439 (follow-up) - vehicle types map to a handover form once
  // delta 215 has added CompanyVehicleType.HandoverForm_Id.
  const handoverReady = (companyVehicleTypeListAPI || []).some(
    (t) => t && Object.prototype.hasOwnProperty.call(t, "HandoverForm_Id")
  );
  const handoverFields = (row) =>
    handoverReady ? { HandoverForm_Id: row?.HandoverForm_Id || null } : {};
  const [forms, setForms] = useState([]);
  useEffect(() => {
    if (!checkTypeScheduleReady && !handoverReady) return;
    let active = true;
    listFormApi().then((res) => {
      if (!active || res?.status !== 200) return;
      setForms(res.form_list || []);
    });
    return () => {
      active = false;
    };
  }, [checkTypeScheduleReady, handoverReady]);
  const formOptions = [...forms]
    .sort((a, b) => String(a.Name || "").localeCompare(String(b.Name || "")))
    .map((f) => ({
      value: String(f.Id),
      label:
        String(f.Status || "").toLowerCase() === "published"
          ? f.Name
          : `${f.Name} (draft)`,
    }));
  const scheduleFields = (row) =>
    checkTypeScheduleReady
      ? {
          Form_Id: row?.Form_Id || null,
          RepeatIntervalDays:
            Number(row?.RepeatIntervalDays) > 0
              ? Number(row.RepeatIntervalDays)
              : null,
          // Change #100677 - the backend drops it until its delta has run.
          RepeatIntervalUnit:
            Number(row?.RepeatIntervalDays) > 0
              ? row?.RepeatIntervalUnit || null
              : null,
        }
      : {};

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagActive: "0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Company Vehicle Status create
      dispatch(createCompanyVehicleStatus([createStatus]));
    }
    if (activeTab === "2") {
      // Company Vehicle Type create
      dispatch(
        createCompanyVehicleType([
          { ...createStatus, ...handoverFields(createStatus) },
        ])
      );
    }
    if (activeTab === "3") {
      // Company Vehicle Check Type create - no colour fields on this lookup
      dispatch(
        createCompanyVehicleCheckType([
          {
            Name: createStatus?.Name,
            FlagMileageBased: createStatus?.FlagMileageBased ?? "0",
            FlagActive: createStatus?.FlagActive,
            ...scheduleFields(createStatus),
          },
        ])
      );
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = companyVehicleStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = companyVehicleTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "3") {
      data = companyVehicleCheckTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [
    companyVehicleStatusListAPI,
    companyVehicleTypeListAPI,
    companyVehicleCheckTypeListAPI,
    activeTab,
  ]);

  useEffect(() => {
    dispatch(listCompanyVehicleStatus());
    dispatch(listCompanyVehicleType());
    dispatch(listCompanyVehicleCheckType());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Status",
    },
    {
      id: "2",
      name: "Types",
    },
    {
      id: "3",
      name: "Check Types",
    },
    // Change #100679 - named check schedules, assigned to each check.
    {
      id: "4",
      name: "Check Schedules",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      dispatch(deleteCompanyVehicleStatus([deleteStatus]));
    }
    if (activeTab === "2") {
      dispatch(deleteCompanyVehicleType([deleteStatus]));
    }
    if (activeTab === "3") {
      dispatch(deleteCompanyVehicleCheckType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Company Vehicle Status update
        dispatch(
          updateCompanyVehicleStatus([
            {
              Id: updateItemStatus?.Id,
              Name: updateItemStatus?.Name,
              CssColourBackground: updateItemStatus?.CssColourBackground,
              CssColourText: updateItemStatus?.CssColourText,
              FlagActive: updateItemStatus?.FlagActive,
            },
          ])
        );
      }
      if (activeTab === "2") {
        // Company Vehicle Type update
        dispatch(
          updateCompanyVehicleType([
            {
              Id: updateItemStatus?.Id,
              Name: updateItemStatus?.Name,
              CssColourBackground: updateItemStatus?.CssColourBackground,
              CssColourText: updateItemStatus?.CssColourText,
              ...handoverFields(updateItemStatus),
            },
          ])
        );
      }
      if (activeTab === "3") {
        // Company Vehicle Check Type update
        dispatch(
          updateCompanyVehicleCheckType([
            {
              Id: updateItemStatus?.Id,
              Name: updateItemStatus?.Name,
              FlagMileageBased: updateItemStatus?.FlagMileageBased,
              FlagActive: updateItemStatus?.FlagActive,
              ...scheduleFields(updateItemStatus),
            },
          ])
        );
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    companyVehicleStatusCreateSuccessAPI,
    companyVehicleStatusUpdateSuccessAPI,
    companyVehicleStatusDeleteSuccessAPI,
  } = useSelector((state) => ({
    companyVehicleStatusCreateSuccessAPI:
      state.CompanyVehicle.companyVehicleStatusCreate,
    companyVehicleStatusUpdateSuccessAPI:
      state.CompanyVehicle.companyVehicleStatusUpdate,
    companyVehicleStatusDeleteSuccessAPI:
      state.CompanyVehicle.companyVehicleStatusDelete,
  }));

  // Add New Status response
  useEffect(() => {
    if (isEmpty(companyVehicleStatusCreateSuccessAPI)) return;
    if (companyVehicleStatusCreateSuccessAPI?.status === 200) {
      toast.success(companyVehicleStatusCreateSuccessAPI?.message);
      dispatch(listCompanyVehicleStatus());
    } else {
      toast.error(companyVehicleStatusCreateSuccessAPI?.message);
    }
    dispatch(createCompanyVehicleStatusSuccess([]));
  }, [companyVehicleStatusCreateSuccessAPI]);
  // Update Status response
  useEffect(() => {
    if (isEmpty(companyVehicleStatusUpdateSuccessAPI)) return;
    if (companyVehicleStatusUpdateSuccessAPI?.status === 200) {
      toast.success(companyVehicleStatusUpdateSuccessAPI?.message);
      dispatch(listCompanyVehicleStatus());
    } else {
      toast.error(companyVehicleStatusUpdateSuccessAPI?.message);
    }
    dispatch(updateCompanyVehicleStatusSuccess([]));
  }, [companyVehicleStatusUpdateSuccessAPI]);
  // Delete Status response
  useEffect(() => {
    if (isEmpty(companyVehicleStatusDeleteSuccessAPI)) return;
    if (companyVehicleStatusDeleteSuccessAPI?.status === 200) {
      toast.success(companyVehicleStatusDeleteSuccessAPI?.message);
      dispatch(listCompanyVehicleStatus());
      setDeleteModal(false);
    } else {
      toast.error(companyVehicleStatusDeleteSuccessAPI?.message);
    }
    dispatch(deleteCompanyVehicleStatusSuccess([]));
  }, [companyVehicleStatusDeleteSuccessAPI]);

  const {
    companyVehicleTypeCreateSuccessAPI,
    companyVehicleTypeUpdateSuccessAPI,
    companyVehicleTypeDeleteSuccessAPI,
  } = useSelector((state) => ({
    companyVehicleTypeCreateSuccessAPI:
      state.CompanyVehicle.companyVehicleTypeCreate,
    companyVehicleTypeUpdateSuccessAPI:
      state.CompanyVehicle.companyVehicleTypeUpdate,
    companyVehicleTypeDeleteSuccessAPI:
      state.CompanyVehicle.companyVehicleTypeDelete,
  }));

  // Add New Type response
  useEffect(() => {
    if (isEmpty(companyVehicleTypeCreateSuccessAPI)) return;
    if (companyVehicleTypeCreateSuccessAPI?.status === 200) {
      toast.success(companyVehicleTypeCreateSuccessAPI?.message);

      dispatch(listCompanyVehicleType());
    } else {
      toast.error(companyVehicleTypeCreateSuccessAPI?.message);
    }
    dispatch(createCompanyVehicleTypeSuccess([]));
  }, [companyVehicleTypeCreateSuccessAPI]);
  // Update Type response
  useEffect(() => {
    if (isEmpty(companyVehicleTypeUpdateSuccessAPI)) return;
    if (companyVehicleTypeUpdateSuccessAPI?.status === 200) {
      toast.success(companyVehicleTypeUpdateSuccessAPI?.message);

      dispatch(listCompanyVehicleType());
    } else {
      toast.error(companyVehicleTypeUpdateSuccessAPI?.message);
    }
    dispatch(updateCompanyVehicleTypeSuccess([]));
  }, [companyVehicleTypeUpdateSuccessAPI]);
  // Delete Type response
  useEffect(() => {
    if (isEmpty(companyVehicleTypeDeleteSuccessAPI)) return;
    if (companyVehicleTypeDeleteSuccessAPI?.status === 200) {
      toast.success(companyVehicleTypeDeleteSuccessAPI?.message);
      dispatch(listCompanyVehicleType());
      setDeleteModal(false);
    } else {
      toast.error(companyVehicleTypeDeleteSuccessAPI?.message);
    }
    dispatch(deleteCompanyVehicleTypeSuccess([]));
  }, [companyVehicleTypeDeleteSuccessAPI]);

  const {
    companyVehicleCheckTypeCreateSuccessAPI,
    companyVehicleCheckTypeUpdateSuccessAPI,
    companyVehicleCheckTypeDeleteSuccessAPI,
  } = useSelector((state) => ({
    companyVehicleCheckTypeCreateSuccessAPI:
      state.CompanyVehicle.companyVehicleCheckTypeCreate,
    companyVehicleCheckTypeUpdateSuccessAPI:
      state.CompanyVehicle.companyVehicleCheckTypeUpdate,
    companyVehicleCheckTypeDeleteSuccessAPI:
      state.CompanyVehicle.companyVehicleCheckTypeDelete,
  }));

  // Add New Check Type response
  useEffect(() => {
    if (isEmpty(companyVehicleCheckTypeCreateSuccessAPI)) return;
    if (companyVehicleCheckTypeCreateSuccessAPI?.status === 200) {
      toast.success(companyVehicleCheckTypeCreateSuccessAPI?.message);
      dispatch(listCompanyVehicleCheckType());
    } else {
      toast.error(companyVehicleCheckTypeCreateSuccessAPI?.message);
    }
    dispatch(createCompanyVehicleCheckTypeSuccess([]));
  }, [companyVehicleCheckTypeCreateSuccessAPI]);
  // Update Check Type response
  useEffect(() => {
    if (isEmpty(companyVehicleCheckTypeUpdateSuccessAPI)) return;
    if (companyVehicleCheckTypeUpdateSuccessAPI?.status === 200) {
      toast.success(companyVehicleCheckTypeUpdateSuccessAPI?.message);
      dispatch(listCompanyVehicleCheckType());
    } else {
      toast.error(companyVehicleCheckTypeUpdateSuccessAPI?.message);
    }
    dispatch(updateCompanyVehicleCheckTypeSuccess([]));
  }, [companyVehicleCheckTypeUpdateSuccessAPI]);
  // Delete Check Type response
  useEffect(() => {
    if (isEmpty(companyVehicleCheckTypeDeleteSuccessAPI)) return;
    if (companyVehicleCheckTypeDeleteSuccessAPI?.status === 200) {
      toast.success(companyVehicleCheckTypeDeleteSuccessAPI?.message);
      dispatch(listCompanyVehicleCheckType());
      setDeleteModal(false);
    } else {
      toast.error(companyVehicleCheckTypeDeleteSuccessAPI?.message);
    }
    dispatch(deleteCompanyVehicleCheckTypeSuccess([]));
  }, [companyVehicleCheckTypeDeleteSuccessAPI]);

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteStatus}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
      />
      <SettingsPanel
        title="Company Vehicle Settings"
        description="Statuses, types, compliance check types and check schedules for the company fleet. Vehicles keep a deleted lookup's id - remove statuses, types and check types only when no vehicle uses them."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        {activeTab === "4" ? (
          <CheckSchedulesPanel />
        ) : (
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            bankAccountStatus={activeTab === "1" || activeTab === "3"}
            mileageBased={activeTab === "3"}
            checkTypeSchedule={
              activeTab === "3" && checkTypeScheduleReady
                ? { formOptions }
                : activeTab === "2" && handoverReady
                ? {
                    formOptions,
                    formField: "HandoverForm_Id",
                    showRepeat: false,
                    placeholder: "Handover form (optional)",
                  }
                : null
            }
          />
        )}
      </SettingsPanel>
    </>
  );
}
